document.addEventListener('click', function(e){
  var t = e.target.closest('[data-menu-toggle]');
  if(t){ document.querySelector('[data-nav]')?.classList.toggle('open'); }
});
// live-update price on product variant change (simple)
document.addEventListener('change', function(e){
  var sel = e.target.closest('[data-variant-select]');
  if(!sel) return;
  var opt = sel.options[sel.selectedIndex];
  var priceEl = document.querySelector('[data-pdp-price]');
  if(priceEl && opt.dataset.price){ priceEl.textContent = opt.dataset.price; }
});
